// Toute l'application de comptabilité vit sous /compta (route client-only Gatsby).
export const COMPTA_BASE_PATH = '/compta'

// Chemins absolus, utilisés pour la navigation (gatsby `navigate`).
// `trailingSlash: 'always'` est actif dans gatsby-config.js.
export const routes = {
    root: `${COMPTA_BASE_PATH}/`,
    dashboard: `${COMPTA_BASE_PATH}/tableau-de-bord/`,
    consultations: `${COMPTA_BASE_PATH}/consultations/`,
    patients: `${COMPTA_BASE_PATH}/patients/`,
    charges: `${COMPTA_BASE_PATH}/charges/`,
    annual: `${COMPTA_BASE_PATH}/annuel/`,
    exportPdf: `${COMPTA_BASE_PATH}/export-pdf/`,
}

// Chemins relatifs, déclarés dans le <Router basepath="/compta"> de src/pages/compta.js.
export const routerPaths = {
    root: '/',
    dashboard: 'tableau-de-bord',
    consultations: 'consultations',
    patients: 'patients',
    charges: 'charges',
    annual: 'annuel',
    exportPdf: 'export-pdf',
}

// Clé de menu ↔ segment d'URL, pour surligner l'onglet courant.
export const menuKeyByPath = {
    [routerPaths.dashboard]: 'dashboard',
    [routerPaths.consultations]: 'consultations',
    [routerPaths.patients]: 'patients',
    [routerPaths.charges]: 'charges',
    [routerPaths.annual]: 'annual',
    [routerPaths.exportPdf]: 'export',
}

/** Renvoie la clé de menu correspondant à un pathname complet. */
export const getMenuKeyFromPathname = (pathname = '') => {
    const segment = pathname
        .replace(COMPTA_BASE_PATH, '')
        .split('/')
        .filter(Boolean)[0]

    return menuKeyByPath[segment] || 'dashboard'
}
